import { AxiosRequestConfig } from 'axios';

export const GENERAL_SETTINGS_API = {
	integrationSettings: (): AxiosRequestConfig => ({
		url: 'vendor/integrations',
		method: 'GET',
	}),
};
